/**
 * Tipos y Contratos para Conteo Cíclico y Ajustes de Kardex (Fase 9F)
 * Archivo: src/types/adjustment.ts
 */

export const STOCK_ADJUSTMENT_REASONS = [
  'Diferencia de Conteo Cíclico',
  'Merma por Rotura / Daño Físico',
  'Material Oxidado / Deformado / Vencido',
  'Sobrante No Registrado / Retazo Reincorporado',
  'Corrección por Conteo Previo Erróneo',
] as const;

export type StockAdjustmentReason = typeof STOCK_ADJUSTMENT_REASONS[number];

export interface StockAdjustmentPayload {
  dashboardId: string;
  insumoId?: string;
  codigo?: string;
  nombre: string;
  conteoFisico: number;
  stockActual: number;
  motivo: StockAdjustmentReason | string;
  justificacion: string;
  costoUnitarioUSD?: number;
  costoReferencialUSD?: number;
  tasaBCV?: number;
  unidad?: string;
  supervisorPin?: string;
  idempotencyKey?: string;
  stockTeoricoAlCapturar?: number;
  isOfflineSync?: boolean;
  silenceTelegram?: boolean;
  autoClampMtoAllocations?: boolean;
}

export interface MtoReconciliationInfo {
  collisionDetected: boolean;
  clamped: boolean;
  previousReserved: number;
  newReserved: number;
  physicalCeiling: number;
  excess: number;
  excessReduced: number;
  affectedProjects: Array<{
    allocId: string;
    proyectoId?: string | null;
    pedidoId?: string | null;
    proyectoNombre: string;
    previousQty: number;
    newQty: number;
    reducedQty: number;
  }>;
}

export interface StockAdjustmentResult {
  status: 'success' | 'error' | 'already_processed';
  message: string;
  folio?: string;
  kardexId?: string;
  dashboardId?: string;
  insumoId?: string;
  itemNombre?: string;
  previousStock?: number;
  newStock?: number;
  newCost?: number;
  delta?: number;
  impactoUSD?: number;
  impactoBs?: number;
  nuevoEstadoStock?: string;
  requiresSupervisorPin?: boolean;
  telegramSilenced?: boolean;
  mtoReconciliation?: MtoReconciliationInfo;
  requestOabReplenishmentQty?: number;
  timestamp?: string;
  error?: string;
}
